
<template>
  <div id="region-select">
    <i-select :value="value" @on-change="handleChange" :size="size" :placeholder="placeholder" :disabled="disabled" :clearable="clearable" :multiple="multiple">
      <i-option v-for="(item,index) in regionList" :key="index" :value="item.id">{{item.text}}</i-option>
    </i-select>
  </div>
</template>
<script>
export default {
  name: "regionSelect",
  props:{
    value:{
      type: [String, Number, Array],
      default: ''
    },
    size:{
      type:[String],
      default: 'default'
    },
    placeholder:{
      type:[String],
      default: '请选择区域'
    },
    disabled:{
      type:[Boolean],
      default: false
    },
    clearable:{
      type:[Boolean],
      default: false
    },
    multiple:{
      type:[Boolean],
      default: false
    },
    selectAll:{
      type:[Boolean],
      default: false
    }
  },
  data(){
    return{
      regionList:[],
    }
  },
  created(){
    this.regionList = JSON.parse(localStorage.getItem('interfaceRegional')) || []
    if (!this.selectAll && this.regionList.length > 0){
      // 去掉id为98的
      this.regionList = this.regionList.filter(e=>{
        return e.id !== 98 && e.id !== 0
      })
    }
  },
  methods:{
    handleChange(val){
      this.$emit('input',val)
      this.$emit('on-change',val)
    }
  },
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/regionSelect/regionSelect.vue